import { useEffect, useRef, useState } from 'react';
import { DriverFinancialModel } from '../../../models/driverFinancial';
import { RiderDayEnum } from '../../../enums/weekRiderEnum';
import { MonthEnum } from '../../../enums/monthEnum';
import { getCurrentRiderDay } from '../../../utils/getCurrentRiderDay';
import { getCurrentMonth } from '../../../utils/getCurrentMonth';
import { getCurrentYear } from '../../../utils/getCurrentYear';
import { FIND_MANY_DRIVER_FINANCIAL } from '../../../lib/endpoints/driverFinancial';
import axios from '../../../lib/axios';
import { convertDateStringToNormalString } from '../../../utils/convertDateFormat';
import { getYearFromDate } from '../../../utils/getYearFormDate';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import moment from 'moment';
import { BalanceModel } from '../../../models/balanceModel';

function filterDataByDate(
  data: DriverFinancialModel[],
  startDate: Date,
  endDate: Date
): DriverFinancialModel[] {
  return data.filter((item) => {
    const updatedAt = new Date(item.updatedAt).setHours(0, 0, 0, 0);
    return updatedAt >= startDate.setHours(0, 0, 0, 0) && updatedAt <= endDate.setHours(0, 0, 0, 0);
  });
}

const useRiderBalanceController = () => {
  const [data, setData] = useState<DriverFinancialModel[]>([]);
  const [filterData, setFilterData] = useState<DriverFinancialModel[]>([]);
  const [selectedData, setSelectedData] = useState<DriverFinancialModel>(null!);
  const [selectedId, setSelectedId] = useState<string>(null!);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [tabRiderDay, setTabRiderDay] = useState<RiderDayEnum>(getCurrentRiderDay());
  const startDateRef = useRef<HTMLInputElement>(null!);
  const endDateRef = useRef<HTMLInputElement>(null!);

  let filterSearchData: DriverFinancialModel[] = data?.filter(
    (item: DriverFinancialModel) =>
      item.rider?.username?.toLowerCase()?.includes(searchValue.toLocaleLowerCase()) ||
      item.createdAt.toLowerCase()?.includes(searchValue.toLocaleLowerCase()) ||
      item?.rider?.driverNo.toLowerCase()?.includes(searchValue.toLowerCase())
  );
  if (startDateRef.current?.value) {
    filterSearchData = filterData.filter(
      (item: DriverFinancialModel) =>
        item.rider?.username?.toLowerCase()?.includes(searchValue.toLocaleLowerCase()) ||
        item.createdAt.toLowerCase()?.includes(searchValue.toLocaleLowerCase()) ||
        item?.rider?.driverNo.toLowerCase()?.includes(searchValue.toLowerCase())
    );
  }

  const filter = filterSearchData;

  const rows: DriverFinancialModel[] = filter.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE
  );

  const isSearchNotFound: boolean = !filterSearchData.length && !!searchValue;
  const countPagination = Math.ceil(filterSearchData.length / DEFAULT_ROWS_PER_PAGE);

  const handleFilterData = () => {
    let newData: DriverFinancialModel[] = data;
    newData = filterDataByDate(
      data,
      new Date(startDateRef.current.value),
      new Date(endDateRef.current.value)
    );
    setFilterData(newData);
  };

  const handleSearch = (e: any) => {
    setSearchValue(e.target.value);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    const getData = data.filter((item: DriverFinancialModel) => item.id === selectedId)[0];
    setSelectedData(getData);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
  };

  const handleOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleFetchData = async () => {
    try {
      setLoadingData(true);
      const response = await axios.post(FIND_MANY_DRIVER_FINANCIAL, {
        filter: {
          clear: false,
          isPaidStatus: false,
        },
      });

      setData(response?.data?.data);
    } catch (err) {
    } finally {
      setLoadingData(false);
    }
  };
  console.log(data);

  useEffect(() => {
    handleFetchData();
  }, []);

  return {
    searchValue,
    handleSearch,
    tabRiderDay,
    handleTabDayRider: (newValue: RiderDayEnum) => setTabRiderDay(newValue),
    currentPage,
    handleChangePage,
    countPagination,
    isSearchNotFound,
    loadingData,
    openMenu,
    handleCloseMenu,
    handleOpenForm,
    rows,
    handleOpenMenu,
    openForm,
    selectedData,
    handleCloseForm,
    handleFetchData,
    handleFilterData,
    startDateRef,
    endDateRef,
  };
};
export default useRiderBalanceController;
